exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cv-dialog-box {\n  background-color: #fcfcfc;\n  padding-bottom: 15px;\n  padding-top: 12px;\n  padding-left: 10px;\n  padding-right: 10px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/everis/code/Dj/front.staff/src/app/message-box/message-box.component.css
// module id = ../../../../../src/app/message-box/message-box.component.css
// module chunks = main